import React, { FunctionComponent } from 'react';
import AccessoriesContainer from './accessories/AccessoriesContainer';
import ServicePlansContainer from './servicePlans/ServicePlansContainer';
import CustomiseExteriorContainer from './CustomiseExteriorContainer';
import CustomiseInteriorContainer from './CustomiseInteriorContainer';
import VariantSelectorContainer from './variantSelector/variantSelectorContainer/VariantSelectorContainer';
import AccessoryPacksContainer from './accessoryPacks/AccessoryPacksContainer';
import SummaryContainer from './summary/SummaryContainer';
import ConfiguratorControlsLayout from '../../../../common/components/layouts/configuratorControlsLayout/ConfiguratorControlsLayout';
import { Box } from '@material-ui/core';
import useIsTablet from '../../../../common/react/useIsTablet';

const CustomiseControls: FunctionComponent = () => {
  const isMobile = useIsTablet();

  return (
    <ConfiguratorControlsLayout>
      <Box pt={!isMobile ? 6 : 0}>
        <VariantSelectorContainer />
      </Box>
      <CustomiseExteriorContainer />
      <CustomiseInteriorContainer />
      <AccessoryPacksContainer />
      <AccessoriesContainer />
      <ServicePlansContainer />
      <SummaryContainer />
    </ConfiguratorControlsLayout>
  );
};

export default CustomiseControls;
